// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { MODELOS_API } from "../views/MainLayout/components/shared/services/modelos";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const modelosFullfilledReducer = makeSetReducer(['modelos/fullfilled']);

export const fetchModelos = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await MODELOS_API.get()
        const data = await response.data;
        dispatch({ type: 'modelos/fullfilled', payload: data })
        const readOnly = JSON.parse(localStorage.getItem('read_only'));
        readOnly.modelos = data;
        localStorage.setItem('read_only', JSON.stringify(readOnly));
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}